import * as React from 'react'
function SvgChat(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M20 6C12.3 6 6 11.425 6 18.25S12.3 30.5 20 30.5c.7 0 1.4 0 1.925-.175L30.5 34v-7.7c2.1-2.1 3.5-4.9 3.5-8.05C34 11.425 27.7 6 20 6z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgChat
